:root {
  --primary-50: oklch(0.982084 0.013244 333.034319);
  --primary-100: oklch(0.965669 0.023247 338.610142);
  --primary-150: oklch(0.948854 0.03339 337.959274);
  --primary-200: oklch(0.93185 0.042831 339.134147);
  --primary-250: oklch(0.910705 0.055741 337.314857);
  --primary-300: oklch(0.887629 0.069703 336.916306);
  --primary-350: oklch(0.86725 0.08373 335.420133);
  --primary-400: oklch(0.84582 0.096185 334.510766);
  --primary-450: oklch(0.784752 0.136018 335.952916);
  --primary-500: oklch(0.723334 0.175513 337.649945);
  --primary-550: oklch(0.661983 0.214363 338.632544);
  --primary-600: oklch(0.601253 0.254233 340.252307);
  --primary-650: oklch(0.536642 0.227232 340.78992);
  --primary-700: oklch(0.470462 0.200119 341.098388);
  --primary-750: oklch(0.406687 0.174181 341.335872);
  --primary-800: oklch(0.340576 0.146851 341.706145);
  --primary-850: oklch(0.282424 0.121774 341.71207);
  --primary-900: oklch(0.22599 0.097183 342.322886);
  --primary-950: oklch(0.168705 0.072287 343.166627);
  --accent-50: oklch(0.981046 0.012805 221.42319);
  --accent-100: oklch(0.962528 0.022535 229.073806);
  --accent-150: oklch(0.945178 0.032646 226.304274);
  --accent-200: oklch(0.926674 0.041663 227.890787);
  --accent-250: oklch(0.911263 0.054737 226.223779);
  --accent-300: oklch(0.896395 0.067447 225.364647);
  --accent-350: oklch(0.87908 0.079726 224.961348);
  --accent-400: oklch(0.864091 0.092143 223.595164);
  --accent-450: oklch(0.793049 0.126377 232.671182);
  --accent-500: oklch(0.719588 0.160232 241.934243);
  --accent-550: oklch(0.647121 0.194114 252.085254);
  --accent-600: oklch(0.575113 0.229834 260.756335);
  --accent-650: oklch(0.504429 0.200565 260.409998);
  --accent-700: oklch(0.433012 0.172764 260.164397);
  --accent-750: oklch(0.360675 0.146274 260.290439);
  --accent-800: oklch(0.289999 0.117296 259.841938);
  --accent-850: oklch(0.238584 0.100105 260.505764);
  --accent-900: oklch(0.190403 0.080719 260.682766);
  --accent-950: oklch(0.138623 0.062732 261.699127);
  --grey-50: oklch(0.985104 0 0);
  --grey-100: oklch(0.970151 0 0);
  --grey-150: oklch(0.95514 0 0);
  --grey-200: oklch(0.94007 0 0);
  --grey-250: oklch(0.920652 0.002558 228.786818);
  --grey-300: oklch(0.901624 0.003538 219.535738);
  --grey-350: oklch(0.882025 0.006111 223.464254);
  --grey-400: oklch(0.863097 0.007776 228.868893);
  --grey-450: oklch(0.753634 0.008885 236.605307);
  --grey-500: oklch(0.645222 0.009348 225.150438);
  --grey-550: oklch(0.536704 0.009767 225.197358);
  --grey-600: oklch(0.426427 0.011202 232.617199);
  --grey-650: oklch(0.386365 0.01045 236.835687);
  --grey-700: oklch(0.348204 0.010712 236.894097);
  --grey-750: oklch(0.308978 0.011017 236.97265);
  --grey-800: oklch(0.269413 0.01036 242.083865);
  --grey-850: oklch(0.223572 0.008405 240.274391);
  --grey-900: oklch(0.175228 0.006346 236.981786);
  --grey-950: oklch(0.126543 0.006953 243.792325);
}
